import { render, staticRenderFns } from "./Koulutus-kiitos.vue?vue&type=template&id=5f4a4f2d&"
import script from "./Koulutus-kiitos.vue?vue&type=script&lang=js&"
export * from "./Koulutus-kiitos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports